import React, { useEffect, useId, useRef, useState } from "react";
import PopupModal from "../../Components/Ui_elements/PopupModal";
import { Box, Button, Grid2, IconButton, Typography } from "@mui/material";
import TextFieldComponent from "../../Components/TextFieldComponent";
import DropdownComponent from "../../Components/DropdownComponent";
import { Add, Delete, Folder } from "@mui/icons-material";
import Btn from "../../Components/Ui_elements/Btn";
import { useDispatch, useSelector } from "react-redux";
import { getGeneralMasterDropDownList, updateJobTemplate } from "../../redux/Thunk/DashboardModule/DashboardThunk";
import { formatDate } from "../../Components/formateDate";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { getCenteredPopupSize } from "../../Helper/Constants";

const EditJobTemplateModal = ({ open, onClose, onSave }) => {
  const dispatch = useDispatch();
  const { dropdowns } = useSelector((state) => state.root.DashboardModule);
  const { resource } = dropdowns;
  const [formData, setFormData] = useState(() => ({}));
  const [instruction, setInstruction] = useState("");

  const { width, height, left, top } = getCenteredPopupSize(0.6, 0.7);
  

  useEffect(() => {
    if (open) {
      dispatch(getGeneralMasterDropDownList({ resource: true }));
      const { template_name, resource_id, job_description, job_work_instruction = "[]" } = open;
      setFormData({
        template_name,
        resource_id,
        job_description,
        job_work_instruction: JSON.parse(job_work_instruction || "[]"),
      });
    }
  }, [open]);

  const handleInputChange = ({ target: { name, value } }) => {
    setFormData((f) => ({ ...f, [name]: value }));
  };
  const handleDeleteInstruction = (id) => {
    setFormData((p) => ({
      ...p,
      job_work_instruction: p.job_work_instruction?.filter((j) => j.work_id !== id),
    }));
  };

  const handleAddInstruction = () => {
    if (!instruction?.length) return;
    setFormData((p) => ({
      ...p,
      job_work_instruction: [
        ...p.job_work_instruction,
        { work_id: Date.now(), work_name: instruction },
      ],
    }));
    setInstruction("");
  };

  const Schema = Yup.object().shape({
    template_name: Yup.string().required("Template Name is required"),
    resource_id: Yup.string().required("Resource is required"),
  });
  const submitBtnRef = useRef()

  const openFileManager = (id) => {
  window.open(
    `/filemanage/item?jobTemplateId=${id}`,
    "FileManagerPopup",
    `width=${width},height=${height},top=${top},left=${left},` +
    "menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes,width=900,height=600"
  );
};


  return (
    <Formik
    enableReinitialize
      initialValues={{
        template_name: formData.template_name || "",
        resource_id: formData.resource_id || "",
        
      }}
      validationSchema={Schema}
      onSubmit={(values) =>onSave({id: open.id, ...formData, ...values})}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
         <Button ref={submitBtnRef} type="submit" sx={{display: 'none'}}></Button>
          <PopupModal
            open={!!open}
            handleClose={onClose}
            size="60"
            title="Edit Job Templete"
            actions={
              <>
                <Btn onClick={() => submitBtnRef?.current?.click()}>Save</Btn>
                <Btn onClick={onClose}>Cancel</Btn>
              </>
            }
          >
            <Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography>
                  Creation Date: <b>{formatDate(open?.created_at)}</b>
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ fontSize: 12, padding: "5px 10px" }}
                  color="info"
                  startIcon={<Folder />}
                  onClick={() => openFileManager(open.id) }
                >
                  File Manager
                </Button>
              </Box>
              <Grid2 container spacing={2} sx={{ my: 2 }}>
                <Grid2 size={{ md: 6, xs: 12 }}>
                  <TextFieldComponent
                    name="template_name"
                    label="Template Name"
                    value={values.template_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.template_name && Boolean(errors.template_name)}
                    helperText={touched.template_name && errors.template_name}
                    fullWidth
                  />
                </Grid2>
                <Grid2 size={{ md: 6, xs: 12 }}>
                  <DropdownComponent
                    options={resource}
                    valueKey="iUserId"
                    labelKey="vUserName"
                    label="Resources"
                    name="resource_id"
                     value={values.resource_id}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.resource_id && Boolean(errors.resource_id)}
                    helperText={touched.resource_id && errors.resource_id}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12 }}>
                  <TextFieldComponent
                    multiline
                    name={"job_description"}
                    label={"Comment"}
                    value={formData?.job_description}
                    onChange={handleInputChange}
                    fullWidth
                    isNotMandatory
                  />
                </Grid2>
              </Grid2>
              <Typography variant="subtitle1" fontWeight={500}>
                Work instructions
              </Typography>
              <Grid2 container gap={2} sx={{ alignItems: "center", mb: 2 }}>
                <Grid2 size="grow">
                  <TextFieldComponent
                    isNotMandatory
                    value={instruction}
                    onChange={(e) => setInstruction(e.target.value)}
                    placeholder="Enter work instructions"
                  />
                </Grid2>
                <Grid2>
                  <IconButton
                    disabled={!instruction?.length}
                    color="primary"
                    sx={{ mt: 1 }}
                    onClick={handleAddInstruction}
                  >
                    <Add />
                  </IconButton>
                </Grid2>
              </Grid2>
              {formData?.job_work_instruction?.map((j, i) => (
                <Grid2
                  container
                  gap={2}
                  sx={{
                    alignItems: "center",
                    pb: 1,
                    borderBottom:
                      i + 1 !== formData?.job_work_instruction?.length ? "1px solid #eee" : "none",
                  }}
                >
                  <Grid2 size="grow">
                    <Typography
                      sx={{ px: 1, fontWeight: 600 }}
                      color="textDisabled"
                      variant="caption"
                    >
                      {i + 1}.
                    </Typography>
                    <Typography component="span">{j?.work_name}</Typography>
                  </Grid2>
                  <Grid2>
                    <IconButton
                      onClick={() => handleDeleteInstruction(j?.work_id)}
                      color="error"
                      sx={{ mt: 1 }}
                    >
                      <Delete />
                    </IconButton>
                  </Grid2>
                </Grid2>
              ))}
            </Box>
          </PopupModal>
        </Form>
      )}
    </Formik>
  );
};

export default EditJobTemplateModal;
